var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "contents" },
    [
      _vm.event && _vm.menu && !_vm.inline
        ? _c(
            "v-menu",
            {
              attrs: {
                left: "",
                activator: `#attendanceActivator${_vm.event.id}`,
              },
              model: {
                value: _vm.openMenu,
                callback: function ($$v) {
                  _vm.openMenu = $$v
                },
                expression: "openMenu",
              },
            },
            [
              _c(
                "v-list",
                _vm._l(_vm.options, function (option) {
                  return _c(
                    "v-list-item",
                    {
                      key: option.name,
                      class: [
                        "soli-round",
                        _vm.adminStatus == option.name
                          ? "soli-status-blue"
                          : null,
                      ],
                      attrs: {
                        disabled:
                          !_vm.can("Override attendance") ||
                          (_vm.event.group_event_id &&
                            option.name == "Courtesy-cancel"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.adminUpdate(option.name, null)
                        },
                      },
                    },
                    [
                      _c(
                        "v-list-item-title",
                        {
                          class:
                            _vm.adminStatus == option.name
                              ? "white--text"
                              : null,
                        },
                        [_vm._v(_vm._s(option.name))]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.event && !_vm.menu && !_vm.inline
        ? _c(
            "v-card",
            {
              staticClass: "w-full safe-bottom",
              class: /*$vuetify.breakpoint.xs ? 'fixed' : 'absolute'*/ "",
              staticStyle: { bottom: "0px" },
              attrs: { elevation: "3", tile: "", light: "" },
            },
            [
              _c(
                "div",
                { staticClass: "flex justify-end mr-3" },
                [
                  _c(
                    "v-btn-toggle",
                    {
                      staticClass: "soli-round",
                      attrs: { group: "" },
                      model: {
                        value: _vm.attendance,
                        callback: function ($$v) {
                          _vm.attendance = $$v
                        },
                        expression: "attendance",
                      },
                    },
                    [
                      _vm.showNow &&
                      !_vm.groupEvent &&
                      (!_vm.attendance ||
                        _vm.attendance == "No-show" ||
                        _vm.groupEvent)
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "soli-round soli-grey",
                              attrs: {
                                value: "No-show",
                                disabled: !!_vm.attendance,
                              },
                              on: {
                                click: function ($event) {
                                  !_vm.attendance ||
                                  _vm.attendance == "Attended"
                                    ? (_vm.noShowChoice = true)
                                    : _vm.checkIn("Status")
                                },
                              },
                            },
                            [_vm._v("No-show")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.attendance !== "No-show" || _vm.groupEvent
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "soli-round soli-red--text",
                              attrs: {
                                value: "Cancelled",
                                disabled: !!_vm.attendance,
                              },
                              on: {
                                click: function ($event) {
                                  !_vm.attendance ||
                                  _vm.attendance == "Attended"
                                    ? _vm.groupEvent
                                      ? (_vm.cancelEventChoice = true)
                                      : (_vm.cancelChoice = true)
                                    : _vm.checkIn("Status")
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.attendance == "Cancelled"
                                    ? _vm.adminStatus || "Cancel"
                                    : "Cancel"
                                )
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showNow && !_vm.groupEvent
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "soli-round soli-green--text",
                              attrs: {
                                value: "Attended",
                                disabled: !!_vm.attendance,
                              },
                              on: {
                                click: function ($event) {
                                  _vm.getPaymentStatus == false
                                    ? (_vm.showPaymentReminder = true)
                                    : !_vm.attendance || _vm.event.cancelled
                                    ? (_vm.showLessonNotes = true)
                                    : _vm.checkIn("Status")
                                },
                              },
                            },
                            [
                              _vm.getPaymentStatus == false
                                ? _c("v-icon", { attrs: { color: "error" } }, [
                                    _vm._v("error"),
                                  ])
                                : _vm._e(),
                              _vm._v("Attended"),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.event.group_event
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "soli-round soli-green--text my-2.5",
                          attrs: {
                            disabled:
                              _vm.event.students.length == 0 ||
                              _vm.groupStatus == "Teacher-cancel",
                            text: "",
                          },
                          on: {
                            click: function ($event) {
                              ;[_vm.$emit("showStudentList")]
                            },
                          },
                        },
                        [_vm._v("Attendance List\n            ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.event && !_vm.menu && _vm.inline
        ? _c(
            "div",
            [
              _c(
                "v-btn-toggle",
                {
                  staticClass: "soli-round items-center",
                  attrs: { group: "" },
                  model: {
                    value: _vm.groupAttendance,
                    callback: function ($$v) {
                      _vm.groupAttendance = $$v
                    },
                    expression: "groupAttendance",
                  },
                },
                [
                  _vm.showNow
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "soli-round soli-grey btn-stack",
                          attrs: {
                            value: "No-show",
                            loading: _vm.loading && _vm.clicked == 1,
                            disabled: ![
                              "Attended",
                              "Early-cancel",
                              null,
                              undefined,
                            ].includes(_vm.groupAttendance),
                          },
                          on: {
                            click: function ($event) {
                              ;[
                                _vm.groupAttendance == "No-show"
                                  ? _vm.checkIn("Status")
                                  : (_vm.noShowChoice = true),
                                (_vm.clicked = 1),
                              ]
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("person_off"),
                          ]),
                          _c("small", { staticClass: "text-none caption" }, [
                            _vm._v("No-show"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "soli-round soli-red--text btn-stack",
                      attrs: {
                        value: _vm.notice,
                        loading: _vm.loading && _vm.clicked == 2,
                        disabled: ![
                          "Attended",
                          "Early-cancel",
                          null,
                          undefined,
                        ].includes(_vm.groupAttendance),
                      },
                      on: {
                        click: function ($event) {
                          ;[
                            _vm.groupAttendance == _vm.notice
                              ? _vm.checkIn("Status")
                              : (_vm.cancelChoice = true),
                            (_vm.clicked = 2),
                          ]
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v("cancel"),
                      ]),
                      _c("small", { staticClass: "text-none caption" }, [
                        _vm._v("Cancel"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showNow
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "soli-round soli-green--text btn-stack",
                          attrs: {
                            value: "Attended",
                            loading: _vm.loading && _vm.clicked == 3,
                          },
                          on: {
                            click: function ($event) {
                              ;[
                                _vm.groupAttendance == "Attended"
                                  ? _vm.checkIn("Status")
                                  : _vm.checkIn("Attended"),
                                (_vm.clicked = 3),
                              ]
                            },
                          },
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                small: "",
                                color:
                                  _vm.getPaymentStatus == false
                                    ? "error"
                                    : "soli-green--text",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getPaymentStatus == false
                                    ? "error"
                                    : "check_circle"
                                )
                              ),
                            ]
                          ),
                          _c("small", { staticClass: "text-none caption" }, [
                            _vm._v("Attended"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.cancelChoice && _vm.event
        ? _c("SoliChoice", {
            ref: "cancelChoice",
            attrs: {
              title: _vm.event.group_event
                ? "Are you sure?"
                : "Who is cancelling?",
              subtitle:
                _vm.notice == "Early-cancel"
                  ? `This lesson is more than ${_vm.event.rescheduleWindow.display} from now and will be able to be rescheduled.`
                  : `This lesson is in less than ${_vm.event.rescheduleWindow.display} and will not be able to be rescheduled, unless due to a teacher absence.`,
              loading1: "",
              loading2: !_vm.event.group_event,
              button1: _vm.event.group_event ? "Confirm" : "Student",
              button2: _vm.event.group_event ? "Nevermind" : "Teacher",
              persistent: "",
              permanent: "",
            },
            on: {
              option1: function ($event) {
                return _vm.checkIn(_vm.notice)
              },
              option2: function ($event) {
                _vm.event.group_event
                  ? _vm.reset(true, true)
                  : _vm.checkIn("Teacher-cancel")
              },
              reset: function ($event) {
                return _vm.reset()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.noShowChoice
        ? _c("SoliChoice", {
            attrs: {
              title: "They didn't show up?",
              subtitle:
                "This lesson cannot be rescheduled. We'll notify the student to check in. You should too!",
              loading1: "",
              button1: "Confirm",
              button2: "Nevermind",
              persistent: "",
              permanent: "",
            },
            on: {
              option1: function ($event) {
                return _vm.checkIn("No-show")
              },
              option2: function ($event) {
                return _vm.reset(true, true)
              },
              reset: function ($event) {
                return _vm.reset()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showPaymentReminder
        ? _c("SoliChoice", {
            attrs: {
              title: "Membership is Past Due",
              subtitle:
                "This student's credit card has likely expired. Please collect new payment information or contact your Community Manager.",
              persistent: "",
              permanent: "",
              button1: "Okay",
            },
            on: {
              option1: function ($event) {
                _vm.showLessonNotes = true
              },
              reset: function ($event) {
                !!$event
                  ? _vm.reset(true, true)
                  : _vm.closeModal(() => (_vm.showPaymentReminder = false))
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmCredit
        ? _c("SoliChoice", {
            attrs: {
              title: "Cancel-credit",
              subtitle: `Cancel-credited lessons are unable to be altered. Would you like to automatically credit this user's account? This will add ${
                _vm.creditPricing ?? "(loading...)"
              }.`,
              button1: "Update and Credit Account",
              button2: "Update Attendance Only",
              left: "",
            },
            on: {
              option1: function ($event) {
                return _vm.adminUpdate("Cancel-credit", true)
              },
              option2: function ($event) {
                return _vm.adminUpdate("Cancel-credit", false)
              },
              reset: function ($event) {
                return _vm.reset()
              },
              "hook:mounted": function ($event) {
                return _vm.getCreditPricing()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.cancelEventChoice
        ? _c("SoliChoice", {
            ref: "cancelEventChoice",
            attrs: {
              title: "Are you sure?",
              subtitle:
                "This class will be cancelled. Students will be notified and will be able to join another class using this purchase option. The teacher will not be paid.",
              button1: "Confirm",
              button2: "Nevermind",
              loading1: "",
              permanent: "",
              persistent: "",
            },
            on: {
              option1: function ($event) {
                return _vm.checkIn("Teacher-cancel")
              },
              option2: function ($event) {
                return _vm.reset(true)
              },
              reset: function ($event) {
                return _vm.reset(true)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      Object.keys(_vm.$page.props.errors).includes("rescheduled")
        ? _c("SoliChoice", {
            attrs: {
              button1: "Okay",
              title: "Error",
              subtitle: _vm.$page.props.errors.rescheduled,
            },
            on: {
              option1: function ($event) {
                _vm.attendance = _vm.storeAttendance
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showLessonNotes
        ? _c("SoliResponsiveDialog", {
            ref: "lessonNotes",
            attrs: {
              persistent: "",
              title: "Tell us about this lesson",
              subtitle: "This note will be shared with students and parents",
              mobileScroll: false,
            },
            on: {
              reset: function ($event) {
                return _vm.reset(true, true)
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        {
                          ref: "attendanceNotesForm",
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.checkIn("Attended")
                            },
                          },
                        },
                        [
                          _c(
                            "v-container",
                            { staticClass: "flex flex-col gap-4" },
                            [
                              _c(
                                "div",
                                { staticClass: "mb-4" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-subtitle-2 font-weight-bold soli-grey px-2 mb-4",
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            `What did you and ${_vm.event.student.first_name} work on?`
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("TipTap", {
                                    ref: "lessonNoteTipTap",
                                    attrs: {
                                      hideSubmit: "",
                                      breakOnEnter: "",
                                      characterLimit: 512,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.saveDraft($event)
                                      },
                                    },
                                    model: {
                                      value: _vm.lesson_note,
                                      callback: function ($$v) {
                                        _vm.lesson_note = $$v
                                      },
                                      expression: "lesson_note",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("v-input", {
                                    staticClass: "px-5",
                                    attrs: {
                                      value: _vm.lesson_note,
                                      rules: _vm.noteRules,
                                      "error-messages": _vm.lessonNoteErrors,
                                      "hide-details": "auto",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mb-4" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-subtitle-2 font-weight-bold soli-grey px-2 mb-4",
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            `What should ${_vm.event.student?.first_name} work on at home?`
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("TipTap", {
                                    ref: "practiceNoteTipTap",
                                    attrs: {
                                      hideSubmit: "",
                                      breakOnEnter: "",
                                      autofocus: false,
                                      characterLimit: 512,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.saveDraft($event)
                                      },
                                    },
                                    model: {
                                      value: _vm.practice_note,
                                      callback: function ($$v) {
                                        _vm.practice_note = $$v
                                      },
                                      expression: "practice_note",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("v-input", {
                                    staticClass: "px-5",
                                    attrs: {
                                      value: _vm.practice_note,
                                      rules: _vm.noteRules,
                                      "error-messages": _vm.practiceNoteErrors,
                                      "hide-details": "auto",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.showDraft
                                ? _c("div", { staticClass: "caption px-2" }, [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          `(draft) last saved: ${_vm.globalMomentDateAtTime(
                                            _vm.event.student.attendance
                                              .updated_at
                                          )}`
                                        ) +
                                        "\n                    "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("SoliBtn", {
                                attrs: {
                                  gradient: "gradient-orange",
                                  loading: _vm.loading,
                                  type: "submit",
                                  text: "Save",
                                  icon: "save",
                                  block: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2680141801
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }